import styled from 'styled-components/macro';
import { device } from '../../styles/devices';

interface IModalOverlayProps {
  isOpen: boolean;
}

export const ModalOverlay = styled.div<IModalOverlayProps>`
  display: ${props => props.isOpen ? 'flex' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background: ${({ theme }) => theme.colors.background};
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  
  @media ${device.mobileMed} {
    padding: 1.5rem;
    width: 95%;
  }
  
  @media ${device.mobileSml} {
    padding: 1rem;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  
  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.text.default };
    font-size: 1.5rem;
    
    @media ${device.mobileMed} {
      font-size: 1.25rem;
    }
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: ${({ theme }) => theme.colors.text.grey};
  border-radius: 4px;
  transition: all 0.2s ease;

  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: ${({ theme }) => theme.colors.text.black};
    background-color: ${({ theme }) => theme.colors.grey.default};
  }
  
  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary.default};
    outline-offset: 2px;
  }
`;

export const FormContainer = styled.form`
  margin-top: 1rem;
`;
